import { memo } from 'react';
// @ts-ignore - react-helmet doesn't have official TypeScript types
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { BRAND_NAME, IS_ADMIN } from '@/services/Constants';

interface HelmetWrapperProps {
	title?: string;
	description?: string;
	titleProps?: Record<string, unknown>;
	descProps?: Record<string, unknown>;
	descContent?: string;
	titleContent?: string;
}

const HelmetWrapper = ({
	title,
	description,
	titleProps,
	descProps,
	descContent,
	titleContent,
}: HelmetWrapperProps) => {
	const { t } = useTranslation();
	const { pathname } = useLocation();

	return (
		<Helmet>
			{(title || titleContent) && (
				<title>
					{titleContent ||
						`${t(title || '', { brandName: BRAND_NAME, ...titleProps })} | ${
							IS_ADMIN ? t('general.admin') : ''
						} ${BRAND_NAME}`}
				</title>
			)}
			{(description || descContent) && (
				<meta
					name="description"
					content={
						descContent || t(description || '', { brandName: BRAND_NAME, ...descProps })
					}
				/>
			)}
		</Helmet>
	);
};

export default memo(HelmetWrapper);
